import React from 'react';
import PropTypes from 'prop-types';
import { bindGa, gaWrapper } from 'helpers/analytics';
import InViewObserver from 'components/InViewObserver';
import Link from 'components/Link';
import { convertHtmlToStringText } from 'utils/common';
import s from './TopComment.scss';

class TopComment extends React.Component {
  constructor() {
    super();
    this.state = {
      // showCompleteTopCmnt: false,
      crownIconVisible: false,
    };

    this.postComment = this.postComment.bind(this);
    this.openSidebar = this.openSidebar.bind(this);
  }

  @bindGa({})
  postComment(e) {
    e.stopPropagation();
    this.props.onSidebarOpenClose(this.props.msid);
    setTimeout(() => {
      const { commentTextInput } = this.props;
      const elem = document.getElementById(
        `comment-sidebar-input-${this.props.msid}`,
      );
      if (elem && elem.length) {
        elem.focus();
      }

      if (
        !this.props.isWapView &&
        commentTextInput.current &&
        typeof commentTextInput.current.focus === 'function'
      ) {
        commentTextInput.current.focus();
      }
    }, 0);
  }

  @bindGa({})
  openSidebar(e, id) {
    if (!(this.props.isTablet && this.props.isTablet())) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }

    this.props.onSidebarOpenClose(this.props.msid, id);
  }

  getReadCommentsBtn = commentsCount => {
    let commentsWord =
      commentsCount > 1
        ? `(${commentsCount}) comments`
        : `(${commentsCount}) comment`;
    commentsWord = this.props.isWapView ? 'all' : commentsWord;
    const readCommentsTxt = `Read ${commentsWord}`;
    if (commentsCount !== 0) {
      if (this.props.isWapView) {
        return (
          <Link
            className={`${s.startcomment}`}
            href={`${
              this.props.href
                ? this.props.href.replace('articleshow', 'articleshow_comments')
                : '/'
            }`}
            data-ga={
              this.props.isEtimesArticle
                ? `${this.props.gaAction}-read_comment`
                : `${this.props.gaAction}|read${this.props.gaLabel}`
            }
          >
            {readCommentsTxt}
          </Link>
        );
      }
      return (
        <span
          className={`${s.startcomment}`}
          data-ga={`${this.props.gaAction}|read${this.props.gaLabel}`}
          onClick={e => this.openSidebar(e)}
        >
          {' '}
          {readCommentsTxt}
        </span>
      );
    }
    return null;
  };

  getPostCommentBtn = () => {
    const postCommentText = 'Post comment';
    const { crownIconVisible } = this.state;
    if (this.props.isWapView) {
      return (
        <Link
          className={`${s.startcomment} ${s.writeacomment}`}
          data-ga={
            this.props.isEtimesArticle
              ? `${this.props.gaAction}-add_comment`
              : `${this.props.gaAction}|add${this.props.gaLabel}`
          }
          href={`${
            this.props.href
              ? this.props.href.replace('articleshow', 'articleshow_comments')
              : '/'
          }`}
        >
          {postCommentText}
        </Link>
      );
    }
    return (
      <span
        className={`${s.startcomment} ${s.writeacomment}`}
        data-ga={
          this.props.isEtimesArticle
            ? `${this.props.gaAction}-add_comment`
            : `${this.props.gaAction}|add${this.props.gaLabel}`
        }
        onClick={e => this.postComment(e)}
      >
        {postCommentText}
      </span>
    );
  };

  onCommentClick = (e, commentId) => {
    gaWrapper('send', 'event', `BTF_comments`, 'top_comment');
    this.openSidebar(e, commentId);
  };

  commentBtnUi = () => (
    <div className={s.commentbtn}>
      {this.getReadCommentsBtn(this.props.commentsCount)}
      {!this.props.isPrivateUser && this.getPostCommentBtn()}
    </div>
  );

  getTopCommentSection = () => {
    if (this.props.commentsData) {
      if (
        (this.props.isWapView && this.props.commentsData.length >= 2) ||
        (!this.props.isWapView && this.props.commentsData.length > 1)
      ) {
        let topComment;
        let commentId = '';
        let isPriorityComment = false;
        const attr = {};
        if (this.props.isWapView) {
          attr.href = this.props.href.replace(
            'articleshow',
            'articleshow_comments',
          );
        }
        // eslint-disable-next-line react/prop-types
        const { priorityComment } = this.props.commentsData[0];
        let commentTxt = '';

        if (priorityComment && priorityComment.length > 0) {
          commentTxt = convertHtmlToStringText(
            unescape(priorityComment[0].C_T),
          );
          topComment = priorityComment[0];
          isPriorityComment = true;
        } else {
          topComment = this.props.commentsData[1];
          commentTxt = convertHtmlToStringText(unescape(topComment.C_T));
          commentId = topComment._id;
        }

        const heading =
          (topComment && topComment.AC_A_C > 1) || isPriorityComment
            ? 'Top Comment'
            : 'Latest Comment';
        let cmntTxtDiv;

        if (commentTxt) {
          cmntTxtDiv = (
            <a {...attr} onClick={e => this.onCommentClick(e, commentId)}>
              <span className="cmnt-text">{commentTxt}</span>
              {commentTxt.length > 220 && (
                <span className={s.showmore}>Read More</span>
              )}
            </a>
          );
        }

        let commentUser;
        if (this.props.isWapView) {
          commentUser = (
            <a
              className={`${s.username}`}
              href={`${
                this.props.href
                  ? this.props.href.replace(
                      'articleshow',
                      'articleshow_comments',
                    )
                  : '/'
              }`}
            >
              {topComment.F_NAME}
            </a>
          );
        } else {
          commentUser = (
            <div
              className={`${s.username}`}
              //onClick={() => this.onSidebarOpenClose(true)}
            >
              {topComment.F_NAME}
            </div>
          );
        }

        return (
          <div className={`${s.topcmntcontainer}`}>
            <div className={`${s.topcmnttitle}`}>
              <i />
              <span className={s.commentHead}>{heading}</span>
              {!this.props.isWapView && this.commentBtnUi()}
            </div>
            <div className={s.comment_user_cont}>
              <i>
                {topComment.F_NAME && topComment.F_NAME[0]
                  ? topComment.F_NAME[0]
                  : ''}
              </i>
              <div className={s.userWrap}>
                {commentUser}
                <span className={s.comment_time}>{topComment.C_D}</span>
              </div>
            </div>

            <div className={s.comment_message}>
              {this.props.isWapView && <span className={s.comment_arrow} />}
              {cmntTxtDiv}
            </div>
            {this.props.isWapView && this.commentBtnUi()}
          </div>
        );
      } else if (this.props.isWapView && this.props.commentsData.length === 0) {
        return (
          <div className={`${s.commentbtn}`}>
            <div className={`${s.startcomment} ${s.writeacomment}`}>
              START A CONVERSATION
            </div>
            <div className={s.startcomment}>{this.getPostCommentBtn()}</div>
          </div>
        );
      }
    }
    return null;
  };

  getEmptyTopCommentsHtml = () => (
    <div className={s.nocomments}>
      <div className={s.start_comment}>
        <i className="mobile-sprite" />Start a Conversation
      </div>
      <div className={s.commentbtn}>
        {!this.props.isPrivateUser && this.getPostCommentBtn()}
      </div>
    </div>
  );

  render() {
    if (
      this.props.commentModeration === '4.0' ||
      this.props.commentModeration === '3.0'
    ) {
      return null;
    }

    let commentHtml;
    if (this.props.commentsCount === 0) {
      commentHtml = this.getEmptyTopCommentsHtml();
    } else {
      commentHtml = this.getTopCommentSection();
    }

    return (
      <>
        {commentHtml && (
          <div
            className={
              !this.props.isWapView
                ? `${s.commentsContainer} cmtwrapper ${
                    this.props.embeddedWithAds ? s.tccommentwrapper : ''
                  }`
                : `${this.props.commentsCount === 0 ? s.nocommentwrapper : ''}`
            }
          >
            {commentHtml}
          </div>
        )}
      </>
    );
  }
}

TopComment.propTypes = {
  commentsData: PropTypes.arrayOf(PropTypes.shape({})),
  msid: PropTypes.string.isRequired,
  commentsCount: PropTypes.number,
  onSidebarOpenClose: PropTypes.func.isRequired,
  isWapView: PropTypes.bool,
  isTablet: PropTypes.func.isRequired,
  isPrivateUser: PropTypes.bool,
  commentModeration: PropTypes.string,
  embeddedWithAds: PropTypes.bool,
  commentTextInput: PropTypes.shape({}),
  // gaCategory: PropTypes.string,
  gaAction: PropTypes.string,
  gaLabel: PropTypes.string,
  isEtimesArticle: PropTypes.bool,
};

TopComment.defaultProps = {
  commentsData: [],
  isWapView: false,
  commentsCount: 0,
  isPrivateUser: true,
  commentModeration: '',
  embeddedWithAds: false,
  commentTextInput: {},
  // gaCategory: '',
  gaAction: '',
  gaLabel: '',
  isEtimesArticle: false,
};

export default TopComment;
